import React from "react";

const Home = () => {
  const handleLogin = () => {
    const CLIENT_ID = "648408600203-3ek66ajea66itdqgmit3cob56m9u0hpo.apps.googleusercontent.com";
    const REDIRECT_URI = "https://astonishing-tiramisu-e7a822.netlify.app/calendar"; // Match your backend redirect URI
   // const SCOPE = "https://www.googleapis.com/auth/calendar";
    const SCOPE = "https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile";
//const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=${SCOPE}&access_type=offline`;

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=${SCOPE}&access_type=offline&prompt=consent`;

    // Redirect the user to the Google OAuth consent screen
    window.location.href = authUrl;
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Welcome to the Calendar App</h1>
      <button onClick={handleLogin} style={styles.button}>
        Sign in with Google
      </button>
    </div>
  );
};

const styles = {
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#4285F4",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default Home;
